import { defineStore } from "pinia";
export const useValidationStore = defineStore("validation", {
    state: () => ({
        errors: {}
    }),
    actions: {
        setErrors(errors) {
            this.errors = errors || {};
        },
        clear() {
            this.errors = {};
        },
        getErrors(field) {
            return this.errors[field]?.[0] || null;
        },
        hasError(field) {
            return !!this.errors[field];
        }
    }
})
